export const UPDATE_SELECTED_YEAR_GROUP = 'UPDATE_SELECTED_YEAR_GROUP';

export const updateSelectedYearGroup = selectedYearGroup =>
    ({ type: UPDATE_SELECTED_YEAR_GROUP, selectedYearGroup });

export const UPDATE_ASSIGN_STUDENT_SEARCH_TERM = 'UPDATE_ASSIGN_STUDENT_SEARCH_TERM';

export const updateSearchTerm = searchTerm =>
    ({ type: UPDATE_ASSIGN_STUDENT_SEARCH_TERM, searchTerm });

export const GET_STUDENT_CLASSROOMS_RELATION_REQUEST = 'GET_STUDENT_CLASSROOMS_RELATION_REQUEST';
export const GET_STUDENT_CLASSROOMS_RELATION_SUCCESS = 'GET_STUDENT_CLASSROOMS_RELATION_SUCCESS';
export const GET_STUDENT_CLASSROOMS_RELATION_FAILURE = 'GET_STUDENT_CLASSROOMS_RELATION_FAILURE';

export const getStudentClassroomsRelationRequest = (userProfileId, productId) =>
    ({ type: GET_STUDENT_CLASSROOMS_RELATION_REQUEST, userProfileId, productId });

export const getStudentClassroomsRelationSuccess = classrooms =>
    ({ type: GET_STUDENT_CLASSROOMS_RELATION_SUCCESS, classrooms });

export const getStudentClassroomsRelationFailure = () =>
    ({ type: GET_STUDENT_CLASSROOMS_RELATION_FAILURE });

export const ASSIGN_STUDENT_REQUEST = 'ASSIGN_STUDENT_REQUEST';
export const ASSIGN_STUDENT_SUCCESS = 'ASSIGN_STUDENT_SUCCESS';
export const ASSIGN_STUDENT_FAILURE = 'ASSIGN_STUDENT_FAILURE';

export const assignStudentRequest = (assignedClassrooms, userProfileId, productId) =>
    ({ type: ASSIGN_STUDENT_REQUEST, assignedClassrooms, userProfileId, productId, isSaveInProgress: true });

export const assignStudentSuccess = () =>
    ({ type: ASSIGN_STUDENT_SUCCESS, isSaveInProgress: false });

export const assignStudentFailure = () =>
    ({ type: ASSIGN_STUDENT_FAILURE, isSaveInProgress: false });

export const UPDATE_CLASSROOM_REQUEST = 'UPDATE_CLASSROOM_REQUEST';

export const updateClassrooms = () =>
    ({ type: UPDATE_CLASSROOM_REQUEST });

export const CLOSE_ASSIGN_CONFIRMATION_MODAL_REQUEST = 'CLOSE_ASSIGN_CONFIRMATION_MODAL_REQUEST';

export const closeAssignConfirmationModal = () =>
    ({ type: CLOSE_ASSIGN_CONFIRMATION_MODAL_REQUEST });

export const CANCEL_USER_ASSIGN_REQUEST = 'CANCEL_USER_ASSIGN_REQUEST';

export const cancelUserAssign = () =>
    ({ type: CANCEL_USER_ASSIGN_REQUEST });

export const RESET_USER_CLASSROOM_RELATION = 'RESET_USER_CLASSROOM_RELATION';

export const resetUserClassroomRelation = () =>
    ({ type: RESET_USER_CLASSROOM_RELATION });

export const GET_TEACHER_CLASSROOMS_RELATION_REQUEST = 'GET_TEACHER_CLASSROOMS_RELATION_REQUEST';
export const GET_TEACHER_CLASSROOMS_RELATION_SUCCESS = 'GET_TEACHER_CLASSROOMS_RELATION_SUCCESS';
export const GET_TEACHER_CLASSROOMS_RELATION_FAILURE = 'GET_TEACHER_CLASSROOMS_RELATION_FAILURE';

export const getTeacherClassroomsRelationRequest = (userProfileId, productId) =>
    ({ type: GET_TEACHER_CLASSROOMS_RELATION_REQUEST, userProfileId, productId });

export const getTeacherClassroomsRelationSuccess = classrooms =>
    ({ type: GET_TEACHER_CLASSROOMS_RELATION_SUCCESS, classrooms });

export const getTeacherClassroomsRelationFailure = () =>
    ({ type: GET_TEACHER_CLASSROOMS_RELATION_FAILURE });

export const ASSIGN_TEACHER_REQUEST = 'ASSIGN_TEACHER_REQUEST';
export const ASSIGN_TEACHER_SUCCESS = 'ASSIGN_TEACHER_SUCCESS';
export const ASSIGN_TEACHER_FAILURE = 'ASSIGN_TEACHER_FAILURE';

export const assignTeacherRequest = (assignedClassrooms, userProfileId, productId) =>
    ({ type: ASSIGN_TEACHER_REQUEST, assignedClassrooms, userProfileId, productId, isSaveInProgress: true });

export const assignTeacherSuccess = () =>
    ({ type: ASSIGN_TEACHER_SUCCESS, isSaveInProgress: false });

export const assignTeacherFailure = () =>
    ({ type: ASSIGN_TEACHER_FAILURE, isSaveInProgress: false });

export const CLASSROOM_TEACHER_MAPPING_SUCCESS = 'CLASSROOM_TEACHER_MAPPING_SUCCESS';

export const classroomTeacherMappingSuccess = () =>
    ({ type: CLASSROOM_TEACHER_MAPPING_SUCCESS });

export const ASSIGN_TEACHER_TO_CLASSROOM_REQUEST = 'ASSIGN_TEACHER_TO_CLASSROOM_REQUEST';
export const ASSIGN_TEACHER_TO_CLASSROOM_SUCCESS = 'ASSIGN_TEACHER_TO_CLASSROOM_SUCCESS';
export const ASSIGN_TEACHER_TO_CLASSROOM_FAILURE = 'ASSIGN_TEACHER_TO_CLASSROOM_FAILURE';

export const assignTeacherToClassroomRequest = (teacherClassroomMapping, context) =>
    ({ type: ASSIGN_TEACHER_TO_CLASSROOM_REQUEST, teacherClassroomMapping, context, isSaveInProgress: true });

export const assignTeacherToClassroomSuccess = (context) => {
    context.history.push('/teachers');
    return ({ type: ASSIGN_TEACHER_TO_CLASSROOM_SUCCESS, isSaveInProgress: false });
};

export const assignTeacherToClassroomFailure = () =>
    ({ type: ASSIGN_TEACHER_TO_CLASSROOM_FAILURE, isSaveInProgress: false });



// WEBPACK FOOTER //
// ./app/containers/assign-user/actions.js